export default "__VITE_ASSET__BXf8FIVw__"